import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import PlusIcon from "../../../../assets/icons/PlusIcon";
import Spinner from "../../../../assets/icons/Spinner";
import Message from "../../../../i18n/Message";
import GatewayTile from "./GatewayTile";
import CreateGatewayDialog from "./CreateGatewayDialog";
import { loadGateways } from "../store/gatewayActionCreators";
import { gatewaySelectors } from "../store/gatewayReducer";
import NewWorkspaceLayout from "../../layout/NewWorkspaceLayout";

import "./GatewayListPage.scss";

const GatewayListPage = () => {
  const [showCreate, setShowCreate] = useState(false);
  const dispatch = useDispatch();
  const intl = useIntl();
  const { workspaceId } = useParams();
  const gatewayList = useSelector(gatewaySelectors.getList);
  const listCounter = useSelector(gatewaySelectors.getListCounter);

  useEffect(() => {
    if (workspaceId) {
      dispatch(loadGateways(intl, workspaceId));
    }
  }, [dispatch, intl, workspaceId, listCounter]);

  return (
    <NewWorkspaceLayout contentPanelClassName="gateway_list_page">
      <div className="breadcrumbs">&nbsp;</div>
      <h1>
        <Message id="menu_gateways" />
      </h1>
      <div className="actions_panel">
        <button
          className="btn btn-outline-dark"
          onClick={() => setShowCreate(true)}
        >
          <PlusIcon size="18" color="#344767" />
          <Message id="create_gateway" />
        </button>
      </div>
      <div className="body_content">
        <div className="campaign_tiles">
          {!gatewayList && <Spinner />}
          {gatewayList && gatewayList.length === 0 && (
            <div className="empty_state">
              <Message id="no_gateways_yet" />
            </div>
          )}
          {gatewayList &&
            gatewayList.map((gateway) => (
              <GatewayTile key={gateway.uid} gateway={gateway} />
            ))}
        </div>
      </div>
      {showCreate && (
        <CreateGatewayDialog onClose={() => setShowCreate(false)} />
      )}
    </NewWorkspaceLayout>
  );
};

export default GatewayListPage;
